import React, { useState, useEffect, useCallback, useReducer } from "react";
import { Table, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import ModalCondicion from "./ModalCondicion";
import { 
  getAllCondiciones, 
  insertCondicion, 
  updateCondicion,getAdminCredentials
} from "../../../Api/AdminApi";

import "./CondicionesManager.css";

const showReducer = (curShow, state) => {
  switch (state.type) {
    case "SHOW":
      return {
        isShow: true,
        typeModal: state.typeModal,
        item: state.item || null,
      };
    case "END":
      return { ...curShow, isShow: false };
    default:
      return curShow;
  }
};

const CondicionesManager = () => {
  const [Condiciones, setCondiciones] = useState([]);
  const [filtroCondicion, setFiltroCondicion] = useState("");
  const [datoCondicion, setDatoCondicion] = useState({});
  const [isnewCondicion, setIsnewCondicion] = useState(true);

  const [userdata, setUserdata] = useState(null); // <-- guardar info del usuario

  const [reducer, dispatchReducer] = useReducer(showReducer, {
    isShow: false,
    typeModal: null,
    item: null,
  });

  // Cargar condiciones
  const cargarCondiciones = useCallback(async () => {
    try {
      const condicionesResult = await getAllCondiciones();
      setCondiciones([...condicionesResult.result]);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo cargar las condiciones.",
        confirmButtonColor: "#00273a",
      });
    }
  }, []);

  // Cargar credenciales del usuario
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const result = await getAdminCredentials();
       
        setUserdata(result);
      } catch (err) {
        console.error("Error obteniendo usuario", err);
      }
    };
    fetchUser();
    cargarCondiciones();
  }, [cargarCondiciones]);

  const handleShowCondicion = (item = null) => {
    const dato = item || {
      cod: "",
      condicion: "",
      idcondiciones: "",
    };
    setDatoCondicion(dato);
    setIsnewCondicion(!item);
    dispatchReducer({ type: "SHOW", typeModal: "CONDICION" });
  };

  const onReturnDataCondicion = async (data, isnew) => {
    dispatchReducer({ type: "END" });
    Swal.fire({
      title: "Guardando Condición",
      allowOutsideClick: false,
      showConfirmButton: false,
    });
    try {
      const codLower = data.cod.trim().toLowerCase();
      const existeCodigo = Condiciones.some(
        (item) =>
          item.cod.trim().toLowerCase() === codLower &&
          String(item.idcondiciones) !== String(data.idcondiciones)
      );

      if (existeCodigo) {
        Swal.close();
        Swal.fire({
          icon: "warning",
          title: "Código duplicado",
          text: `Ya existe una condición con el código "${data.cod}".`,
          confirmButtonColor: "#00273a",
        });
        return;
      }

      const result = isnew ? await insertCondicion(data) : await updateCondicion(data);

      if (result) {
        Swal.close();
        Swal.fire({
          title: "Condición Guardada",
          text: "La condición se guardó correctamente",
          icon: "success",
          confirmButtonColor: "#00273a",
        });
        cargarCondiciones();
      }
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${err}`,
        confirmButtonColor: "#00273a",
      });
    }
  };

  const onCloseModal = () => {
    dispatchReducer({ type: "END" });
  };

  const listaFiltrada = Condiciones.filter(
    (item) =>
      item?.cod?.toLowerCase().includes(filtroCondicion.toLowerCase()) ||
      item?.condicion?.toLowerCase().includes(filtroCondicion.toLowerCase())
  );

  // Validar permiso: solo 0 y 1 pueden editar/agregar
  const puedeEditar = userdata?.IdTipoUsuario === "0" || userdata?.IdTipoUsuario === "1";

  return (
    <div className="card">
      <div className="card-header border-0 pb-0">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h4 className="card-title mb-0">Condiciones de presupuesto</h4>
          <div className="d-flex align-items-center gap-2">
            <Form.Control
              size="sm"
              type="text"
              placeholder="Buscar por código o condición..."
              value={filtroCondicion}
              onChange={(e) => setFiltroCondicion(e.target.value)}
              style={{ width: "220px" }}
            />
            {filtroCondicion && (
              <Button
                size="sm"
                variant="outline-primary"
                onClick={() => setFiltroCondicion("")}
              >
                Limpiar
              </Button>
            )}
          
              <Button
                variant="primary"
                size="sm"
                onClick={() => handleShowCondicion()}
              >
                Agregar
              </Button>
          
          </div>
        </div>
      </div>
     <div className="card-body">
  <div className="table-responsive" >
    <Table striped bordered  className="table-sticky-header mb-0">
      <thead>
        <tr>
          <th><strong>Código</strong></th>
          <th><strong>Condición</strong></th>
          <th><strong>Opciones</strong></th>
        </tr>
      </thead>
      <tbody>
        {listaFiltrada.map((item, index) => (
          <tr key={index}>
            <td>{item.cod}</td>
            <td
             style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}
              dangerouslySetInnerHTML={{ __html: item.condicion }}
            />
            <td>
              <div className="d-flex">
                {puedeEditar && (
                  <li
                    className="btn btn-primary shadow btn-xs sharp me-1"
                    onClick={() => handleShowCondicion(item)}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </li>
                )}
              </div>
            </td>
          </tr>
        ))}
        {listaFiltrada.length === 0 && (
          <tr>
            <td colSpan={3} className="text-center text-muted py-4">
              No hay resultados
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
</div>


      {reducer.isShow && reducer.typeModal === "CONDICION" && (
        <ModalCondicion
          estado={reducer.isShow}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnDataCondicion}
          item={datoCondicion}
          isnew={isnewCondicion}
        />
      )}
    </div>
  );
};

export default CondicionesManager;
